import { render, staticRenderFns } from "./HdPieChart.vue?vue&type=template&id=65b0123d&scoped=true&"
import script from "./HdPieChart.vue?vue&type=script&lang=js&"
export * from "./HdPieChart.vue?vue&type=script&lang=js&"
import style0 from "./HdPieChart.vue?vue&type=style&index=0&id=65b0123d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b0123d",
  null
  
)

export default component.exports